module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-Bold-043771c9.ttf";